import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import MiniChart from "components/atoms/chart/parts/MiniChart"
import SpChart from "components/atoms/chart/parts/SpChart"
import useChartInitialize from "components/atoms/chart/parts/useChartInitialize"
import * as Formatter from "utils/Formatter"
import { get, pick, isEmpty, includes } from "lodash"
import {
  checkIsSp,
  getCountryIcon,
  getPriceCompareText,
  getPriceOrLastClose,
  priceCompareIcon,
  open_chart,
} from "utils/util"
import ClassNames from "classnames"
import { BaseSelect } from "components/atoms/input/select"
import { changeSymbol } from "redux/ducks/Chart"
import { EXCHANGE } from "config/const"

type Option = {
  id: number | string
  name: string
  disabled?: boolean
  cls?: string
  icon?: string
}

type PropsType = {
  data: object
  dataList?: Array<object>
  hasIcon?: boolean
  id?: string
  lineType?: boolean
  selectOption?: Array<Option>
  listNum?: number
  changeList?: Function
  linkTechChart?: boolean
  labelVisible?: boolean
}

export const MiniChartComponent: React.FC<PropsType> = props => {
  const { data, id, lineType, labelVisible } = props
  const [priceCompareText, setPriceCompareText] = useState("")
  const linkTechChart = !!props.linkTechChart
  const isPhone = checkIsSp()
  const _id = id || null
  const canvasId = useChartInitialize({
    symbolData: data,
    chartType: !isPhone ? "mini" : "sp",
    id: _id,
  })
  const symbolDetailSelector = (state: any) =>
    state.chart[canvasId].symbolDetail
  const symbolDetail = useSelector(symbolDetailSelector)
  const priceCompare = get(symbolDetail, "PriceCompare")
  const iconClass = priceCompareIcon(priceCompare)

  const dispatch = useDispatch()
  const param = useMemo(() => {
    return pick(symbolDetail, ["SecurityType", "Exchange", "Symbol"])
  }, [symbolDetail])
  const NumberOfDecimals = useMemo(() => {
    return get(symbolDetail, "NumberOfDecimals", 0)
  }, [symbolDetail])
  const icon = getCountryIcon(symbolDetail)

  //為替,国債,商品（金現物,銀現物）はPriceがnullの場合はLastClose,LastCloseTimeを使用する
  const [_price, _priceTime] = getPriceOrLastClose(symbolDetail)
  const symbolsUseGetPriceOrLastClose = includes(
    [EXCHANGE.FX.id, EXCHANGE.GB.id, EXCHANGE.XAU_XAG.id],
    get(symbolDetail, "Exchange")
  )

  useEffect(() => {
    get(symbolDetail, "PriceCompare")
      ? getPriceCompareText(
          get(symbolDetail, "PriceCompare"),
          priceCompareText,
          setPriceCompareText
        )
      : setPriceCompareText("")
  }, [symbolDetail])

  return (
    <li>
      {!lineType ? (
        <div className="list-body price-detail-col price-detail-col-list">
          {/* テスト的にdata-symbol追加してます。 */}
          {/* <span {...GetAttribute(2011, "6501.HKE", 2011, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(2031, "6501.TWE", 2031, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(1, "8411", 1, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(101, "163060018", 2, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(13020, "AUGBY02", 13000, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(14001, "XAU", 14000, "MarketInfoFull")} /> */}
          {/* {/1* <span {...GetAttribute(14106, "USGBY07", 14106, "MarketInfoFull")} /> *1/} */}
          <div className="price-detail-row">
            <div className="price-detail-title">
              {/*{props.hasIcon ? (*/}
              {/*  <i className="icon-solid icon-jp icon-m" />*/}
              {/*) : null}*/}
              {props.selectOption ? (
                <BaseSelect
                  option={props.selectOption}
                  value={props.listNum}
                  onChange={(id: number) => {
                    dispatch(changeSymbol(canvasId, props.dataList[id]))
                    props.changeList(id)
                  }}
                />
              ) : (
                <div className="index-name-row">
                  <i className={ClassNames("icon-solid ", icon)} />
                  {labelVisible ? (
                    <div className="symbol-code-label">
                      {Formatter.symbol(props.data)}
                    </div>
                  ) : (
                    <span className="index-name ellipsis-text">
                      {get(symbolDetail, "SymbolNameS", "") ||
                        get(symbolDetail, "SymbolName", "")}
                    </span>
                  )}
                </div>
              )}
            </div>
            {labelVisible && (
              <div className="index-name ellipsis-text">
                {get(symbolDetail, "SymbolNameS", "") ||
                  get(symbolDetail, "SymbolName", "")}
              </div>
            )}
            <div className="price-detail-value-col right-justify">
              <div className="price-detail-currency-col">
                <div className="price-detail-currency-value-col">
                  <div className="price-detail-currency-value">
                    {Formatter.number(
                      symbolsUseGetPriceOrLastClose
                        ? _price
                        : get(symbolDetail, "Price", null),
                      NumberOfDecimals
                    )}
                  </div>
                  <i
                    className={ClassNames("material-icons", iconClass, {
                      empty: isEmpty(priceCompareText),
                    })}
                  >
                    {priceCompareText}
                  </i>
                </div>
                <div className="time-col">
                  {Formatter.date(
                    symbolsUseGetPriceOrLastClose
                      ? _priceTime
                      : get(symbolDetail, "PriceTime", ""),
                    "MM/DD HH:mm"
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="price-detail-row">
            <div className="price-detail-value-col right-justify">
              <div className="price-detail-currency-col">
                <div className="price-detail-change-price-col">
                  <div
                    className={ClassNames(
                      "price-detail-change-price",
                      Formatter.upDown(get(symbolDetail, "ChangedPrice"))
                    )}
                  >
                    {Formatter.number(
                      get(symbolDetail, "ChangedPrice", null),
                      NumberOfDecimals,
                      "floor",
                      true
                    )}
                  </div>
                  <div className="price-detail-change-ratio">
                    (
                    <span
                      className={ClassNames(
                        Formatter.upDown(get(symbolDetail, "ChangedRatio"))
                      )}
                    >
                      {Formatter.number(
                        get(symbolDetail, "ChangedRatio", null),
                        2,
                        "floor",
                        true
                      )}
                    </span>
                    <span className="unit">%</span>)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="list-body price-detail-col price-detail-col-list">
          {/* テスト的にdata-symbol追加してます。 */}
          {/* <span {...GetAttribute(2011, "6501.HKE", 2011, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(2031, "6501.TWE", 2031, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(1, "8411", 1, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(101, "163060018", 2, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(13020, "AUGBY02", 13000, "MarketInfoFull")} /> */}
          {/* <span {...GetAttribute(14001, "XAU", 14000, "MarketInfoFull")} /> */}
          {/* {/1* <span {...GetAttribute(14106, "USGBY07", 14106, "MarketInfoFull")} /> *1/} */}
          {/*TODO:ミニチャート：レイアウト調整中*/}
          <div className="price-detail-row">
            <div className="price-detail-title">
              <div className="index-name-row">
                <i className={ClassNames("icon-solid ", icon)} />
                <span className="index-name ellipsis-text">
                  {get(symbolDetail, "SymbolNameS", "") ||
                    get(symbolDetail, "SymbolName", "")}
                </span>
              </div>
            </div>
            <div className="price-detail-value-col right-justify row-type-one">
              <div className="price-detail-currency-col">
                <div className="price-detail-currency-value">
                  {Formatter.number(
                    symbolsUseGetPriceOrLastClose
                      ? _price
                      : get(symbolDetail, "Price", null),
                    NumberOfDecimals
                  )}
                </div>
                <i
                  className={ClassNames("material-icons", iconClass, {
                    empty: isEmpty(priceCompareText),
                  })}
                >
                  {priceCompareText}
                </i>
              </div>
              <div className="price-detail-currency-col">
                <div className="price-detail-change-price-col">
                  <div
                    className={ClassNames(
                      "price-detail-change-price",
                      Formatter.upDown(get(symbolDetail, "ChangedPrice"))
                    )}
                  >
                    {Formatter.number(
                      get(symbolDetail, "ChangedPrice", null),
                      NumberOfDecimals,
                      "floor",
                      true
                    )}
                  </div>
                  <div className="price-detail-change-ratio">
                    (
                    <span
                      className={ClassNames(
                        Formatter.upDown(get(symbolDetail, "ChangedRatio"))
                      )}
                    >
                      {Formatter.number(
                        get(symbolDetail, "ChangedRatio", null),
                        2,
                        "floor",
                        true
                      )}
                    </span>
                    <span className="unit">%</span>)
                  </div>
                </div>
              </div>
              <div className="time-col">
                {Formatter.date(
                  symbolsUseGetPriceOrLastClose
                    ? _priceTime
                    : get(symbolDetail, "PriceTime", ""),
                  "MM/DD HH:mm"
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className="mini-chart-wrapper"
        onClick={() => {
          if (!linkTechChart || isPhone) return
          open_chart(param, symbolDetail)
        }}
      >
        {!isPhone ? (
          <MiniChart
            canvasId={canvasId}
            miniChartFlag={true}
            linkTechChart={linkTechChart}
          />
        ) : (
          <SpChart canvasId={canvasId} />
        )}
      </div>
    </li>
  )
}
